export default "__VITE_ASSET__DBfADnLR__"